module.exports = __webpack_public_path__ + "img/23_114.d3e56998.png";